import { Trigger } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Address } from "../../contactUpdateInquiries/Address";
import { useContactUpdateInquiry } from "../../contactUpdateInquiries/ContactUpdateInquiryProvider";
import {
	PrimaryLabel,
	ViewPageSection,
	ViewPageSectionBody,
	ViewPageSectionHeader,
	ViewPageSectionListItem,
} from "../../shared/view";
import { ValueWrapper } from "../../shared/view/ViewComponents";
import { ContactCompanyDrawer } from "./ContactCompanyDrawer";

const StyledViewPageSection = styled(ViewPageSection)`
	grid-area: companies;
`;

const CompanyWrapper = styled.div`
	display: grid;
`;

const StyledPrimaryLabel = styled(PrimaryLabel)`
	align-self: center;
`;

export const ContactViewCompaniesSection: FC = () => {
	const { t } = useTranslation();
	const { companies, setCompanies } = useContactUpdateInquiry();

	return (
		<StyledViewPageSection>
			<ViewPageSectionHeader>{t("Companies")}</ViewPageSectionHeader>
			<ViewPageSectionBody>
				{companies.map((x, index) => (
					<Trigger
						key={index}
						render={(props) => (
							<ContactCompanyDrawer
								open={props.open}
								onClose={props.handleClose}
								title={t("Edit company")}
								initialValues={{
									id: x.id,
									position: x.position,
									name: x.name,
									isPrimary: x.isPrimary,
									primaryAddress: x.primaryAddress,
								}}
								onClosed={() => void 0}
								onSubmit={async (values) => {
									if (!values.name) throw "Missing validation for field: company";

									setCompanies((current) =>
										current.map((company, innerIndex) =>
											innerIndex === index
												? {
														id: company.id,
														name: company.name,
														position: values.position,
														isPrimary: values.isPrimary,
														primaryAddress: company.primaryAddress,
													}
												: { ...company, isPrimary: values.isPrimary ? false : company.isPrimary },
										),
									);

									return true;
								}}
							/>
						)}
					>
						{(props) => (
							<ViewPageSectionListItem {...props}>
								<ValueWrapper>
									<CompanyWrapper>
										<strong>{x.name}</strong>
										{x.primaryAddress && <Address address={x.primaryAddress} />}
										<span>{x.position}</span>
									</CompanyWrapper>
									{x.isPrimary && <StyledPrimaryLabel />}
								</ValueWrapper>
							</ViewPageSectionListItem>
						)}
					</Trigger>
				))}
			</ViewPageSectionBody>
		</StyledViewPageSection>
	);
};
